import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateCategory($companyId: ID!, $attributes: CategoryAttributes!) {
    createCategory(companyId: $companyId, attributes: $attributes) {
      category {
        id
        ...CreatedCategory
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedCategory on Category {
    id
    name
    fullname
    color
    parent { id name fullname color }
  }
`
